/* Cozyleigh design kit: shared motion (phase 1). Loaded once from layout/theme.liquid.
   - .cl-rv / .cl-rv-img rise or settle in as they come into view; .cl-words headlines rise word by word.
     All of it sits behind html.cl-m (set in snippets/cl-kit-head.liquid unless reduced motion is on).
   - .cl-acc details glide open and closed with the Web Animations API.
   - [data-cl-stamp] stamps land once when they scroll into view; CozyleighKit.stamp(el, card) replays one.
   Re-runs on shopify:section:load so the theme editor keeps working. */
(function () {
  var root = document.documentElement;
  var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var moving = root.classList.contains('cl-m') && !still && 'IntersectionObserver' in window;
  var EASE = 'cubic-bezier(.22,.61,.36,1)';

  function all(scope, sel) { return [].slice.call(scope.querySelectorAll(sel)); }

  function splitWords(el) {
    if (el.getAttribute('data-cl-split')) return;
    el.setAttribute('data-cl-split', '1');
    var i = 0;
    (function walk(node) {
      [].slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          var frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(function (t) {
            if (!t) return;
            if (/^\s+$/.test(t)) { frag.appendChild(document.createTextNode(t)); return; }
            var w = document.createElement('span');
            w.className = 'cl-w'; w.style.setProperty('--i', i++); w.textContent = t;
            frag.appendChild(w);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1 && !n.classList.contains('cl-w')) {
          // a highlighted word rises as one piece so its tape stays whole, and keeps any punctuation right after it
          // (the "." in "your order.") on the same line
          if (n.classList.contains('cl-hl')) {
            var w = document.createElement('span');
            w.className = 'cl-w'; w.style.setProperty('--i', i++);
            n.parentNode.insertBefore(w, n); w.appendChild(n);
            var next = w.nextSibling;
            if (next && next.nodeType === 3) {
              var m = next.textContent.match(/^[^\s]+/);
              if (m) { w.appendChild(document.createTextNode(m[0])); next.textContent = next.textContent.slice(m[0].length); }
            }
          } else walk(n);
        }
      });
    })(el);
  }

  function reveal(scope) {
    all(scope, '.cl-words').forEach(splitWords);
    var targets = all(scope, '.cl-rv, .cl-rv-img, .cl-words').filter(function (t) { return !t.classList.contains('cl-in'); });
    // children of a .cl-stagger group come in one after another
    all(scope, '.cl-stagger').forEach(function (g) {
      [].slice.call(g.children).forEach(function (c, k) { if (!c.style.getPropertyValue('--d')) c.style.setProperty('--d', (k % 4) * 0.08 + 's'); });
    });
    if (!moving) { targets.forEach(function (t) { t.classList.add('cl-in'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('cl-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    targets.forEach(function (t) { io.observe(t); });
  }

  function accordion(scope) {
    all(scope, '.cl-acc details').forEach(function (d) {
      if (d.getAttribute('data-cl-acc')) return;
      d.setAttribute('data-cl-acc', '1');
      var sum = d.querySelector('summary'), body = d.querySelector('.cl-acc__body'), anim = null;
      if (!sum || !body || !body.animate) return;
      sum.addEventListener('click', function (e) {
        if (still) return; // native toggle
        e.preventDefault();
        if (anim) anim.cancel();
        if (!d.open) {
          d.open = true;
          var h = body.scrollHeight;
          anim = body.animate([{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }], { duration: 520, easing: EASE });
          anim.onfinish = function () { anim = null; };
        } else {
          var h2 = body.scrollHeight;
          anim = body.animate([{ height: h2 + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 420, easing: EASE });
          anim.onfinish = function () { d.open = false; anim = null; };
        }
      });
    });
  }

  function stamp(el, card) {
    if (!el) return;
    el.classList.remove('cl-stampit'); void el.offsetWidth; el.classList.add('cl-stampit');
    if (card) { card.classList.remove('cl-thud'); void card.offsetWidth; card.classList.add('cl-thud'); }
  }

  function stamps(scope) {
    var list = all(scope, '[data-cl-stamp]').filter(function (s) { return !s.classList.contains('cl-stampit'); });
    if (!moving) { list.forEach(function (s) { s.classList.add('cl-stampit'); }); return; }
    list.forEach(function (s) {
      var delay = parseInt(s.getAttribute('data-cl-stamp'), 10) || 200;
      var card = s.closest('[data-cl-stamp-card]');
      var io = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        io.disconnect();
        setTimeout(function () { stamp(s, card); }, delay);
      }, { threshold: .6 });
      io.observe(s);
    });
  }

  function init(scope) { scope = scope || document; reveal(scope); accordion(scope); stamps(scope); }

  window.CozyleighKit = { init: init, stamp: stamp };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* Country pickers (snippets/localization): their lists start empty. The first time a picker is about to open, the
   options are copied in from the one <template id="cl-country-options"> (snippets/cl-country-options), so a page
   carries one copy of the 237 countries instead of three. Filling happens in the capture phase, before the theme's
   own toggle shows the list. The theme connects options when the page loads, so a pick in a filled list is handled
   here, the same way the theme does it: set the hidden input and submit the picker's form. */
(function () {
  function fill(list) {
    var t = document.getElementById('cl-country-options');
    if (!list || !t || list.getAttribute('data-cl-filled')) return;
    list.appendChild(t.content.cloneNode(true));
    list.setAttribute('data-cl-filled', '1');
  }
  function onToggle(e) {
    // The header and phone-menu pickers share a list id, so find the list inside the picker that was used.
    var toggle = e.target.closest && e.target.closest('[data-disclosure-country] [data-disclosure-toggle]');
    if (toggle) fill(toggle.closest('[data-disclosure-country]').querySelector('[data-cl-countries]'));
  }
  ['pointerdown', 'focusin', 'click'].forEach(function (type) { document.addEventListener(type, onToggle, true); });
  document.addEventListener('click', function (e) {
    var option = e.target.closest && e.target.closest('[data-cl-countries] [data-disclosure-option]');
    if (!option) return;
    e.preventDefault();
    var picker = option.closest('[data-disclosure-country]');
    picker.querySelector('[data-disclosure-input]').value = option.getAttribute('data-value');
    var form = picker.closest('form');
    if (window.jQuery) window.jQuery(form).submit(); else form.submit();
  });
})();

/* Sticky header: when the theme hides the announcement bar on scroll, the header slides up by the bar's height
   (cozyleigh-kit.css) instead of the bar shrinking, so the page under it doesn't move. --cl-ann-h is the bar's height. */
(function () {
  var watcher;
  function watch() {
    var nav = document.getElementById('site-control');
    var bar = nav && nav.querySelector('.cc-announcement');
    if (watcher) watcher.disconnect();
    if (!bar) return;
    var measure = function () { nav.style.setProperty('--cl-ann-h', bar.offsetHeight + 'px'); };
    measure();
    if ('ResizeObserver' in window) { watcher = new ResizeObserver(measure); watcher.observe(bar); }
  }
  watch();
  window.addEventListener('resize', watch);
  document.addEventListener('shopify:section:load', watch);
})();
